// 默认轮播图
export const defaultSlideShowList = [
    {
        coverPic: require("@/assets/list/banners.png")
    },
];
